import * as React from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

export const movementIcon = {
  up: <TbChevronUp size={25} color="#0075AC" />,
  down: <TbChevronDown size={25} color="red" />,
};

export const rankingLabels = {
  steps: "Pasos",
  distance: "Distancia",
  calories: "Calorías",
  exerciseTime: "Tiempo",
};

/**
 * Formats ranking results for display.
 * @param {Array} results - Raw ranking results from API.
 * @param {string} currentUserId - Current user ID to highlight.
 * @returns {Array} Formatted results with helper properties.
 */
export const formatRankingData = (results, currentUserId) => {
  if (!results) return [];
  return results.map((item, index) => ({
    ...item,
    isCurrentUser: String(item.id) === String(currentUserId),
    displayPosition: index + 1,
    movementSymbol: item.movement
      ? item.movement.direction === "up"
        ? "+"
        : item.movement.direction === "down"
        ? "-"
        : ""
      : "",
    hasMovement: !!item.movement,
    movementAmount: item.movement?.amount > 0 ? item.movement.amount : null,
    movementDirection: item.movement?.direction,
  }));
};
